// extracted by mini-css-extract-plugin
module.exports = {"row":"FoodSidebarTotal_row__U8jyL","total":"FoodSidebarTotal_total__3wDDc","bold":"FoodSidebarTotal_bold__2flsa"};